import api from 'services/inventory/equipment'

export const handleGetMaintenanceActionsDones = async (request: any) => {
  let res = await api.searchMaintenanceActionsDone(request)

  return res?.data?.data ?? []
}
